var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3761",
    "data-name": "Rectangle 3761",
    width: 14,
    height: 10,
    transform: "translate(-0.213 -0.023)",
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86039",
    "data-name": "Group 86039",
    transform: "translate(0.213 0.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86038",
    "data-name": "Group 86038",
    transform: "translate(0 -0.223)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47476",
    "data-name": "Path 47476",
    d: "M0,8.822V1.032A1.384,1.384,0,0,1,1.032,0h11.5a1.39,1.39,0,0,1,1.032,1.032v7.79a1.393,1.393,0,0,1-1.032,1.032H1.032A1.391,1.391,0,0,1,0,8.822M1.031.638c.069.081.108.134.154.18Q3.75,3.375,6.317,5.93a.59.59,0,0,0,.941,0Q9.825,3.371,12.388.812c.045-.045.081-.1.143-.174ZM8.669,5.373c-.328.332-.657.672-.993,1a1.205,1.205,0,0,1-1.786,0c-.336-.332-.661-.675-.977-1l-3.8,3.841H12.469l-3.8-3.841M.623,8.7,4.328,4.963.623,1.216ZM9.242,4.91l3.695,3.735V1.179L9.242,4.91",
    transform: "translate(0 0.101)",
    fill: "#707070"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.43d1de9c3a6b04e6ba5e361ed35e74e6.svg";
export { ForwardRef as ReactComponent };